/* eslint-disable react-hooks/exhaustive-deps */
import '../assets/scss/login.scss'
import Text from '../components/ingka/Text'
import { useTranslation } from 'react-i18next'
import Button from '../components/ingka/Button'
import Load from '../components/ingka/Load'
import { useEffect, useState } from 'react'
import { useMaintenance } from '../hooks/use-maintenance'
import { useAuth } from '../hooks/use-auth'

export default function Login() {
  const { t } = useTranslation('global')
  const [year, setYear] = useState('20**')
  const { data: inMaintenance, isLoading: inMaintenanceIsLoading } =
    useMaintenance()
  const { goToSSO, isLoading: authIsLoading } = useAuth()

  useEffect(() => {
    calculateYear()
  }, [])

  const calculateYear = () => {
    const date = new Date()
    setYear(date.getFullYear())
  }

  return (
    <div className='login'>
      <div className='container'>
        <div className='brand'>
          <Text tagName='h1' className='title'>
            <span>Customer </span>
            <span>Flow</span>
          </Text>
          <Text tagName='h2' headingSize='s' className='subtitle'>
            {t('login.subtitle')}
          </Text>
        </div>
      </div>
      <div className='form'>
        <div className='container'>
          {!(inMaintenanceIsLoading || authIsLoading) && (
            <div className='form-container'>
              {!inMaintenance && (
                <Button
                  data-id='login-btn'
                  type='emphasised'
                  text={t('login.buttonContinue')}
                  onClick={goToSSO}
                ></Button>
              )}
              {inMaintenance && (
                <div>
                  <Text tagName='h3' headingSize='l'>
                    {t('login.appInMaintenanceTitle')}
                  </Text>
                  <Text tagName='p' bodySize='xl'>
                    {t('login.appInMaintenanceMsg')}
                  </Text>
                </div>
              )}
            </div>
          )}
          {(inMaintenanceIsLoading || authIsLoading) && (
            <div className='mt-3'>
              <Load />
            </div>
          )}
        </div>
      </div>
      <div className='copy'>
        <Text tagName='span' bodySize='s'>
          @Digital Spain 2021-{year}
        </Text>
      </div>
    </div>
  )
}
